module.exports = __webpack_public_path__ + "static/media/Background_7.239fce75.svg";